<template>
    <v-card class="default_card large mx-0 my-2 pa-2" elevation="0">
        <!-- <v-form v-model="formValid"> -->
        <v-row>
            <v-col cols="12" class="d-flex justify-start align-center pb-2">
                <h2>Paramètres cabinet pour ce dossier</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="d-flex pr-2 px-2" cols="3">
                <div class="tooltip-container">
                    <v-select-filled
                        ref="signatoryAccountantElement"
                        v-model="signatoryId"
                        :items="users"
                        item-value="value"
                        :label="$t('settings.signatoryAccountant')"
                        density="compact"
                        :item-title="(item) => item.key"
                        style="height: 20px"
                        clearable
                        @click:clear="signatoryId = null"
                        :disabled="auditReportMode"
                    />
                    <v-tooltip activator="parent" v-if="$refs.signatoryAccountantElement">
                        {{ ($refs.signatoryAccountantElement as VSelect).label }}
                    </v-tooltip>
                </div>
                <!-- :rules="requiredRule"
                    required -->
            </v-col>
            <v-col cols="2" class="pr-2">
                <div class="tooltip-container">
                    <oss-date-picker-filled
                        ref="startProductionDateElement"
                        v-model="startProductionDate"
                        label="Date de début"
                        style="flex: 1"
                        :textFieldReadOnly="false"
                        :mandatory="false"
                        :disabled="auditReportMode"
                    />
                    <v-tooltip activator="parent" v-if="$refs.startProductionDateElement">
                        {{ ($refs.startProductionDateElement as OssDatePicker).label }}
                    </v-tooltip>
                </div>
            </v-col>
            <v-col cols="2" class="pr-2">
                <div class="tooltip-container">
                    <oss-date-picker-filled
                        ref="endProductionDateElement"
                        v-model="endProductionDate"
                        label="Date de fin"
                        style="flex: 1"
                        :textFieldReadOnly="false"
                        :mandatory="false"
                        :disabled="auditReportMode"
                    />
                    <v-tooltip activator="parent" v-if="$refs.endProductionDateElement">
                        {{ ($refs.endProductionDateElement as OssDatePicker).label }}
                    </v-tooltip>
                </div>
            </v-col>
        </v-row>
        <!-- </v-form> -->
    </v-card>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Component, toNative, Prop } from "vue-facing-decorator";

import ACCOUNTING_FIRM_CLIENT from "../graphql/billing/AccountingFirmClient.gql";
import COMPANY_USERS from "../graphql/user/PartOfCompanyUsers2.gql";
import { User } from "../store/store";
import { Apollo } from "@/decorators";
import { ComponentBase } from "./ComponentBase";
import { DialogAction } from "../services/dialogAction";
import { getUserDisplayName } from "../services/userServices";
import { getDBFormattedEndDate, getDBFormattedStartDate } from "../services/dateServices";
import { Offer_type } from "@/types/offer.types";

@Component({
    emits: ["form-valid"],
})
export class AccountingFirmClientEdition extends ComponentBase {
    @Prop() companyId;
    @Prop({ default: false }) auditReportMode: boolean;
    startProductionDate = null;
    endProductionDate = null;
    signatoryId = null;

    // formValid = false;
    // beforeMount() {
    //     this.$emit("form-valid", false);
    // }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get company() {
        const currentCompany = this.currentUser.allAvailableCompanies?.find(
            (company) => company.id === this.companyId,
        );
        if (currentCompany) {
            return currentCompany;
        }
        return null;
    }

    get accountingFirmId() {
        if (this.companyAccountingFirm) {
            return this.companyAccountingFirm.id;
        }
        // return this.companyId;
        // if (this.isAccountingFirm) {
        return this.currentUser.company.id;
        // }
        return null;
    }

    // get isAccountingFirm() {
    //     return this.currentUser.company?.accountingFirm;
    // }

    get companyAccountingFirm() {
        return this.$store.state.companyAccountingFirm;
    }

    get activateTagguing() {
        return true;
    }

    get externalId() {
        return this.company?.externalId || null;
    }

    set externalId(value) {
        if (this.company) {
            this.company.externalId = value;
        }
    }

    get requiredRule() {
        return [(v: any) => !!v || this.$t("settings.itemRequired")];
    }

    actions = {
        action: new DialogAction(),
    };

    @Apollo({
        query: ACCOUNTING_FIRM_CLIENT,
        variables() {
            return {
                clientId: this.companyId,
                accountingFirmId: this.accountingFirmId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data.accountingFirmClientFirst) {
                    this.accountingFirmClient = data.accountingFirmClientFirst;
                    // this.managerId = data.accountingFirmClientFirst.accountManager?.id || null
                    this.signatoryId =
                        data.accountingFirmClientFirst.accountingSignatory?.id || null;
                    this.startProductionDate =
                        data.accountingFirmClientFirst.startProductionDate || null;
                    this.endProductionDate =
                        data.accountingFirmClientFirst.endProductionDate || null;
                } else {
                    this.accountingFirmClient = null;
                }
            }
        },
    })
    accountingFirmClient = null;

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.accountingFirmId,
                email_not: null,
            };
        },
        skip() {
            return !this.accountingFirmId || !this.inAdmin;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.users) {
                    const users = [];
                    data.users.forEach((user) => {
                        users.push({
                            value: user.id,
                            key: getUserDisplayName(user),
                        });
                    });
                    users.sort((a, b) => {
                        if (a.key < b.key) return -1;
                        if (a.key > b.key) return 1;
                        return 0;
                    });
                    this.users = users;
                }
            }
        },
    })
    users: Array<any> = [];

    get inAdmin() {
        return this.$store.state.inAdmin;
    }

    get offerType() {
        return this.$store.state.offerType;
    }

    get offerTypeString() {
        switch (this.offerType) {
            case Offer_type.ACCOUNTING_STARTER:
                return "ACCOUNTING_STARTER";
            case Offer_type.ACCOUNTING_BASIC:
                return "ACCOUNTING_BASIC";
            case Offer_type.ACCOUNTING_ESSENTIAL:
                return "ACCOUNTING_ESSENTIAL";
            case Offer_type.ACCOUNTING_PREMIUM:
                return "ACCOUNTING_PREMIUM";
            case Offer_type.BUSINESS_BASIC:
                return "BUSINESS_BASIC";
            case Offer_type.BUSINESS_SMART:
                return "BUSINESS_SMART";
            case Offer_type.BUSINESS_ESSENTIAL:
                return "BUSINESS_ESSENTIAL";
            case Offer_type.BUSINESS_PREMIUM:
                return "BUSINESS_PREMIUM";
            case Offer_type.TRAINING:
                return "TRAINING";
        }

        return null;
    }

    refresh() {
        if (this.$apollo.queries.accountingFirmClient) {
            this.$apollo.queries.accountingFirmClient.refetch();
        }
    }

    async updateAccountingFirmClient(_companyId = "", _offerTypeString = null) {
        // console.log("COUCOU");
        const accountingFirmId = this.accountingFirmId || this.companyId || _companyId;
        const companyId = this.companyId || _companyId;
        let offer = _offerTypeString || this.offerTypeString;
        if (!offer) {
            offer = null;
        }
        if (accountingFirmId && companyId) {
            debugger;
            await this.$apollo.mutate({
                mutation: gql`
                    mutation (
                        $id: ID!
                        $createAccountingSignatory: UserCreateOneInput
                        $updateAccountingSignatory: UserUpdateOneInput
                        $startProductionDate: DateTime
                        $endProductionDate: DateTime
                        $offer: OfferType
                        $clientId: ID!
                        $accountingFirmId: ID!
                    ) {
                        upsertAccountingFirmClient(
                            where: { id: $id }
                            create: {
                                accountingSignatory: $createAccountingSignatory
                                startProductionDate: $startProductionDate
                                endProductionDate: $endProductionDate
                                offer: $offer
                                client: { connect: { id: $clientId } }
                                accountingFirm: { connect: { id: $accountingFirmId } }
                            }
                            update: {
                                accountingSignatory: $updateAccountingSignatory
                                startProductionDate: $startProductionDate
                                endProductionDate: $endProductionDate
                                offer: $offer
                            }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    id: this.accountingFirmClient?.id || "",
                    // accountManager: this.managerId ? {connect: {id: this.managerId}} : undefined,
                    createAccountingSignatory: this.signatoryId
                        ? { connect: { id: this.signatoryId } }
                        : undefined,
                    updateAccountingSignatory: this.signatoryId
                        ? { connect: { id: this.signatoryId } }
                        : undefined,
                    startProductionDate: getDBFormattedStartDate(this.startProductionDate),
                    endProductionDate: getDBFormattedEndDate(this.endProductionDate),
                    offer,
                    accountingFirmId: accountingFirmId,
                    clientId: companyId,
                },
            });
            debugger;
            this.refresh();
        }
    }

    // @Watch("formValid", { immediate: true, deep: true })
    // validateForm() {
    //     if (this.formValid) {
    //         this.$emit("form-valid", true);
    //     } else {
    //         this.$emit("form-valid", false);
    //     }
    // }
}

export default toNative(AccountingFirmClientEdition);
</script>

<style lang="scss" scoped>
.tooltip-container {
    width: 100%;
    height: 100%;
}
</style>
